import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacySk1() {
  return (
    <div>
      <Heading
        type="h3"
        title={
          <>
            {`I.`}
            <br />
            {`Úvodné ustanovenia`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Tieto obchodné podmienky (ďalej len „obchodné podmienky“) prevádzkovateľa webovej stránky vivido.fit - Pavola Hudrana, miesto podnikania Opava, Kateřinky, Zeyerova 1386/14, IČO: 74869663 (ďalej len „poskytovateľ“) upravujú, v súlade s ustanovením § 1751 ods. 1 zákona č. 89/2012 Zb., Občiansky zákonník (ďalej len „Občiansky zákonník“), vzájomné práva a povinnosti zmluvných strán vzniknuté v súvislosti s poskytovaním prístupu do platenej časti webových stránok vivido.fit (ďalej len „zmluva“ či „služba“) uzatvárané medzi poskytovateľom a treťou osobou (ďalej len „používateľ“), ktoré spočívajú najmä v sprístupňovaní vybraného obsahu a archívu (ďalej len „obsah“) prostredníctvom internetového portálu poskytovateľa, ktorý je prevádzkovaný na webovej stránke umiestnenej na internetovej adrese https://vivido.fit (vrátane všetkých subdomén a lokalizovaných variantov – ďalej len „webová stránka“).`}</li>
            <li>{`Právne vzťahy poskytovateľa a používateľa, ktoré nie sú upravené týmito obchodnými podmienkami ani zmluvou, sa riadia Občianskym zákonníkom a súvisiacimi predpismi.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={3} className={sList}>
            <li>{`Znenie obchodných podmienok môže poskytovateľ v primeranom rozsahu jednostranne meniť či dopĺňať, a to najmä v dôsledku zmeny právnych predpisov, technických podmienok prevádzkovania webovej stránky či zmeny licenčných podmienok zo strany tretích osôb využívaných poskytovateľom. Zmena obchodných podmienok bude používateľovi oznámená elektronickou poštou na jeho e-mailovú adresu uvedenú v používateľskom účte, ak bola táto poskytnutá, či zobrazením upozornenia po prihlásení používateľa do jeho používateľského rozhrania. Používateľ môže zmenu obchodných podmienok odmietnuť, a to výpoveďou zmluvy o poskytovaní služieb s výpovednou lehotou 1 mesiac, ktorá začne bežať od prvého dňa mesačného predplatiteľského obdobia nasledujúceho po doručení výpovede a skončí posledným dňom takého obdobia. Výpoveď môže byť odoslaná aj e-mailom z e-mailovej adresy uvedenej v používateľskom účte používateľa alebo z príslušného e-mailu poskytovateľa.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacySk1;
